import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// 如果是PC端，给 .vue 的命名特殊处理，这里多了一级目录 pc/
const path = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
)
  ? ''
  : '/cpn'

const constantRoutes = [
  {
    path: '/',
    name: 'Activity',
    // 这里用 path 来加载不同的 .vue 文件
    component: () => import(`../views/activity${path}`),
    // component:()=>import('../views/registrationFrom/ParticipateFrom.vue'),
    // component:()=>import('../views/registrationFrom/ObtainFrom.vue'),
    meta: {
      TabbarShow: path === '' ? true : false // 需要显示 底部导航
    }
  },
  {
    path: '/middlePage',
    name: 'MiddlePage',
    component: () => import(`../views/login${path}/children/middlePage.vue`)
  },
  {
    path: '/url',
    name: 'Url',
    component: () => import(`../views/login${path}/children/url.vue`)
  },
  {
    path: '/activity/details',
    name: 'ActivityDetails',
    component: () => import(`../views/activity${path}/children/activityDetails.vue`),
    meta: {
      keepAlive: true,
      key: (route) => `${route.query.id}`
    }
  },
  {
    path: '/activity/award',
    name: 'awardWorks',
    component: () => import(`../views/activity${path}/children/awardWorks.vue`),
    meta: {
      keepAlive: true,
      key: (route) => `${route.query.id}`
    }
  },
  {
    path: '/activity/works',
    name: 'Works',
    component: () => import(`../views/activity${path}/children/works.vue`),
    meta: {
      keepAlive: true,
      key: (route) => `${route.query.id}`
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(`../views/login${path}/index.vue`)
  },
  {
    path: '/login/info',
    name: 'LoginInfo',
    component: () => import(`../views/login${path}/children/loginInfo.vue`)
  },
  {
    path: '/login/register',
    name: 'registerInfo',
    component: () => import(`../views/login${path}/children/registerInfo.vue`)
  },
  {
    path: '/activity/upload/wokrs',
    name: 'UploadWorks',
    component: () => import('../views/activity/children/uploadWokrs.vue')
  },
  {
    path: '/explain',
    name: 'Explain',
    component: () => import('../views/activity/children/explain.vue')
  },
  {
    path: '/user',
    name: 'User',
    component: () => import(`../views/user${path}`),
    meta: {
      TabbarShow: path == '' ? true : false // 需要显示 底部导航
    }
  },
  {
    path: '/user/edit',
    name: 'EditUser',
    component: () => import(`../views/user${path}/children/editUser.vue`)
  },
  {
    path: '/user/certification',
    name: 'Certification',
    component: () => import(`../views/user${path}/children/myCertification.vue`)
  },
  // 个人认证
  {
    path: '/user/personalCertificate',
    name: 'PersonalCertificate',
    component: () => import(`../views/user${path}/children/personalCertificate.vue`)
  },
  // 企业认证
  {
    path: '/user/enterpriseCertification',
    name: 'EnterpriseCertification',
    component: () => import(`../views/user${path}/children/enterpriseCertification.vue`)
  },
  // 我的影像
  {
    path: '/user/myNews',
    name: 'MyNews',
    component: () => import(`../views/user/children/myNews.vue`)
  },
  {
    path: '/login/forget',
    name: 'ForGetPassword',
    component: () => import(`../views/login${path}/children/forgetPassword.vue`)
  },
  {
    path: '/works/details',
    name: 'worksDetails',
    // component: () => import(`../views/activity/children/worksDetails.vue`)
    component: () => import(`../views/activity${path}/children/worksDetails.vue`)
  },
  {
    path: '/user/works',
    name: 'UserWorks',
    component: () => import('../views/user/children/userWorks.vue')
  },

  // 签约摄影
  {
    path: '/user/applicationPhotography',
    name: 'ApplicationPhotography',
    component: () => import('../views/user/children/applicationPhotography.vue')
  },
  {
    path: '/user/mycertificate',
    name: 'certificate',
    component: () => import('../views/user/children/mycertificate.vue')
  },
  {
    path: '/user/mycertificate',
    name: 'myawards',
    component: () => import('../views/user/children/mycertificate.vue')
  },
  {
    path: '/mycertificate/certidetails',
    name: 'certidetails',
    component: () => import('../views/user/children/certidetails.vue')
  },
  {
    path: '/activity/details/Listvote',
    name: 'Listvote',
    component: () => import('../views/activity/children/listvote.vue')
    // component: () => import(`../views/activity${path}/children/listvote.vue`)
  },
  {
    path: '/activity/Listvote/division',
    name: 'division',
    component: () => import('../views/activity/children/division.vue')
  },
  {
    path: '/myawards/awardslist',
    name: 'awlist',
    component: () => import('../views/user/children/myawards.vue')
  },
  {
    path: '/activity/works/search',
    name: 'searchList',
    component: () => import('../views/activity/children/searchList.vue')
  },
  {
    path: '/activity/text/show',
    name: 'textShow',
    component: () => import('../views/activity/children/textShow.vue')
  },
  {
    path: '/login/open',
    name: 'Open',
    component: () => import(`../views/login${path}/children/open.vue`)
  },
  {
    path: '/activity/signUp',
    name: 'SignUp',
    component: () => import('../views/activity/children/signUp.vue')
  },
  {
    path: '/activity/dai/signUp',
    name: 'DaiSignUp',
    component: () => import('../views/activity/children/daiSignUp.vue')
  },
  {
    path: '/activity/signUp/uploadworks',
    name: 'signUpUploadWorks',
    component: () => import('../views/activity/children/signUpUploadWorks.vue')
  },
  {
    path: '/registrationFrom/ParticipateFrom',
    name: 'ParticipateFrom',
    component: () => import('../views/registrationFrom/ParticipateFrom.vue')
  },
  {
    path: '/registrationFrom/ObtainFrom',
    name: 'ObtainFrom',
    component: () => import('../views/registrationFrom/ObtainFrom.vue')
  },
  {
    path: '/messageInfo/messageList',
    name: 'messageList',
    component: () => import('../views/messageInfo/messageList.vue')
  },
  {
    path: '/messageInfo/finalistPage',
    name: 'finalistPage',
    component: () => import('../views/messageInfo/finalistPage.vue')
  },
  {
    path: '/negation',
    name: 'negation',
    component: () => import('../views/negation/404.vue')
  },
  // 影像首页
  {
    path: '/toJournalismList',
    name: 'ToJournalismList',
    component: () => import(`../views/toJournalismList${path}`),
    // component: () => import('../views/toJournalismList'),
    meta: {
      TabbarShow: path == '' ? true : false // 需要显示 底部导航
    }
  },
  // contribute

  // 影像详情
  {
    path: '/toJournalismList/journalismDetails',

    name: 'JournalismDetails',
    component: () => import(`../views/toJournalismList${path}/children/journalismDetails`)
    // component: () => import(`../views/toJournalismList/children/journalismDetails`),
  },
  // 影像投稿
  {
    path: '/toJournalismList/contribute',
    name: 'Contribute',
    // component: () => import(`../views/toJournalismList/children/uploadContribute`),
    component: () => import(`../views/toJournalismList${path}/children/uploadContribute`)
  },
  // 画册
  {
    path: '/pictureAlbum',
    name: 'PictureAlbum',
    component: () => import(`../views/pictureAlbum${path}`),
    meta: {
      TabbarShow: path == '' ? true : false // 需要显示 底部导航
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active-class',
  linkExactActiveClass: 'exact-class',
  routes: constantRoutes
})

// router.beforeEach((to, from, next) => {
//   if (to.path == '/') {
//     if (!sessionStorage.getItem('schema')) {
//       console.log(132)
//       next({
//         path: '/negation'
//       })
//     }
//   } else if (to.path == '/negation') {
//     next()
//   }
//   if (to.path == '/CNS') {
//     if (
//       sessionStorage.getItem('schema') == 'CNS' ||
//       sessionStorage.getItem('schema') == null ||
//       sessionStorage.getItem('schema') != 'CNS'
//     ) {
//       sessionStorage.setItem('schema', 'CNS')
//     } else {
//       sessionStorage.clear()
//     }
//     next({
//       path: '/'
//     })
//   } else if (to.path == '/CAC') {
//     if (
//       sessionStorage.getItem('schema') == 'CAC' ||
//       sessionStorage.getItem('schema') == null ||
//       sessionStorage.getItem('schema') != 'CAC'
//     ) {
//       sessionStorage.setItem('schema', 'CAC')
//     } else {
//       sessionStorage.clear()
//     }
//     next({
//       path: '/'
//     })
//   } else if (sessionStorage.getItem('schema')) {
//     next()
//   }
// })
const resolveOriginal = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return resolveOriginal.call(this, location).catch((err) => err)
}

export default router
